import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './Capsules.module.scss';
import WithTooltip from '../WithTooltip';
import Badge from 'js/components/shared/Badge';
import {CAPSULE_TYPES} from './buildCapsules';

const cx = classnames.bind(styles);

const capsuleMap = {
  [CAPSULE_TYPES.DISCOUNT]: function ({data: {text}}) {
    return text?.length ? (
      <Badge className={cx('badge')} color="orange">
        {text}
      </Badge>
    ) : null;
  },
  [CAPSULE_TYPES.BREAKFAST]: function ({data: {text}}) {
    return text?.length ? (
      <Badge className={cx('badge')} color="black-reverse">
        {text}
      </Badge>
    ) : null;
  },
  [CAPSULE_TYPES.NEGOTIATED]: function ({data: {text, color}}) {
    return text?.length ? (
      <Badge className={cx('badge')} style={{backgroundColor: color}} icon="infoCircled">
        {text}
      </Badge>
    ) : null;
  },
  [CAPSULE_TYPES.DEFAULT]: function ({data: {text, color}, other: {discountTooltipText}}) {
    return text?.length ? (
      <Badge className={cx('badge')} style={{backgroundColor: color}} icon="infoCircled">
        {discountTooltipText && (
          <WithTooltip className={cx('tooltip-icon')} tooltip={discountTooltipText}>
            <i className={cx('icon', 'icon-infoCircled')}/>
          </WithTooltip>
        )}
        {text}
      </Badge>
    ) : null;
  },
  [CAPSULE_TYPES.PROMO_NO_REFERENCE]: function ({data: {text, color}}) {
    return text?.length ? (
      <Badge className={cx('badge')} style={{backgroundColor: color}}>
        {text}
      </Badge>
    ) : null;
  },
  [CAPSULE_TYPES.PROMO_DISCOUNTED]: function ({data: {text, color, discount}, other: {discountTooltipText}}) {
    return (
      <>
        {!!discount && (<Badge className={cx('badge')} style={{backgroundColor: color}}>
          -{discount}%
        </Badge>)}
        {!!text?.length && (<Badge className={cx('badge')} color="blue" icon="infoCircled">
          {discountTooltipText && (
            <WithTooltip className={cx('tooltip-icon')} tooltip={discountTooltipText}>
              <i className={cx('icon', 'icon-infoCircled')}/>
            </WithTooltip>
          )}
          {text}
        </Badge>)}
      </>
    )
  },
  'default': function ({data: {text, color}}) {
    return text?.length ? (
      <Badge className={cx('badge')} style={{backgroundColor: color}}>
        {text}
      </Badge>
    ) : null;
  }
}

const Capsules = ({
  capsules,
  discountTooltipText,
  align = 'left',
  className,
}) => {
  if (!capsules?.length) return null;

  return (
    <div className={cx('badge-wrap', align, className)}>
      {capsules.map((capsule, index) => {
        const Component = capsule.type in capsuleMap ? capsuleMap[capsule.type] : capsuleMap.default;

        return (
          <Component
            key={`${capsule.type}-${index}`}
            data={capsule}
            other={{discountTooltipText}}
          />
        );
      })}
    </div>
  );
}

Capsules.propTypes = {
  capsules: PropTypes.arrayOf(PropTypes.object),
  discountTooltipText: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
}

export default Capsules;
